// extracted by mini-css-extract-plugin
export var disclaimer = "SubscribeTodayDisclaimer_disclaimer__f5wcd";